import {
  ActuatorModalityType,
  Slot,
  SlotStatus,
  ThermoActuatorType,
  DeviceDTO,
  ThermoRoomObjectDTO,
  SystemControlType,
} from '@/../client-generator/generated-clients/plants';
import {
  SlotRuleServiceType,
  WorkflowCallbackFunction,
} from './slots-assign-rules-interfaces';
import BaseSlotRuleService from './slots-assign-rules-service';

export default class AssignThermoCoolingPumpSlotRuleService extends BaseSlotRuleService {
  declare roomObject: ThermoRoomObjectDTO;

  constructor(
    roomObject: ThermoRoomObjectDTO,
    workflowCallback: WorkflowCallbackFunction
  ) {
    super(
      roomObject,
      -1,
      ThermoActuatorType.CoolingPump,
      roomObject.actuatorModalityType ?? ActuatorModalityType.None,
      workflowCallback
    );
    this.slotRuleServiceType = SlotRuleServiceType.THERMO_COOLING_ACTUATORS;

    this._noOfAdjacent = this.getNoOfAdjacentSlots(
      roomObject.coolingSystemControlType ?? SystemControlType.None
    );
  }

  addOrUpdateSlot(
    slotViewModel: Slot,
    thermoActuatorType = ThermoActuatorType.None
  ) {
    if (slotViewModel != null) {
      const tmpActuatorType = this.getCurrentThermoActuatorType(
        slotViewModel.thermoActuatorTypes,
        this.roomObject.id
      );
      if (tmpActuatorType == ThermoActuatorType.HeatingAndCoolingPump) {
        super.addOrUpdateSlot(slotViewModel, ThermoActuatorType.HeatingPump);
      } else {
        super.addOrUpdateSlot(
          slotViewModel,
          tmpActuatorType == ThermoActuatorType.HeatingPump
            ? ThermoActuatorType.HeatingAndCoolingPump
            : ThermoActuatorType.CoolingPump
        );
      }
    }
  }

  isSameSystemControlType() {
    return !(
      this.roomObject.heatingSystemControlType != SystemControlType.None &&
      this.roomObject.coolingSystemControlType != SystemControlType.None &&
      this.roomObject.heatingSystemControlType !=
        this.roomObject.coolingSystemControlType
    );
  }

  onSlotMessage(device: DeviceDTO, slot: Slot) {
    if (this.roomObject != null) {
      const tmpActuatorType = this.getCurrentThermoActuatorType(
        slot.thermoActuatorTypes,
        this.roomObject.id
      );
      if (
        !this.isSlotLinkedWithCurrentRoomObject(slot) &&
        this.isSlotLinkedAsPump(slot) &&
        (slot.status == SlotStatus.NotConfigured ||
          slot.status == SlotStatus.Configured)
      ) {
        this.markOrUnmarkSlot(
          this.roomObject,
          slot,
          device,
          SlotStatus.Configured,
          SlotStatus.MarkedForLinking
        );
      } else if (
        (slot.status == SlotStatus.MarkedForLinking ||
          slot.status == SlotStatus.MarkedAdjacent ||
          this.isSlotLinkedWithCurrentRoomObject(slot)) &&
        (this.roomObject.actuatorModalityType ==
          ActuatorModalityType.Separate ||
          this.roomObject.actuatorModalityType == ActuatorModalityType.Mixed) &&
        ((tmpActuatorType == ThermoActuatorType.HeatingAndCoolingPump &&
          slot.status == SlotStatus.MarkedForLinking) ||
          tmpActuatorType == ThermoActuatorType.HeatingPump ||
          (tmpActuatorType == ThermoActuatorType.HeatingAndCoolingPump &&
            slot.status == SlotStatus.MarkedAdjacent))
      ) {
        this.markOrUnmarkSlot(
          this.roomObject,
          slot,
          device,
          SlotStatus.MarkedForLinking,
          SlotStatus.MarkedForLinking
        );
      } else if (
        slot.status == SlotStatus.NotConfigured ||
        tmpActuatorType == ThermoActuatorType.CoolingPump ||
        tmpActuatorType == ThermoActuatorType.HeatingAndCoolingPump
      ) {
        super.onSlotMessage(device, slot);
      }
    }
  }

  isSlotCompatibleForMarking(slot: Slot) {
    const tmpActuatorType = this.getCurrentThermoActuatorType(
      slot.thermoActuatorTypes,
      this.roomObject.id
    );
    return (
      slot != null &&
      (tmpActuatorType == ThermoActuatorType.HeatingPump ||
        tmpActuatorType == ThermoActuatorType.HeatingAndCoolingPump ||
        this.isSlotRoomObjectTypeMatchingAndNotLinked(slot) ||
        this.isSlotLinkedAsPump(slot))
    );
  }

  updateForSlotChanging(slot: Slot) {
    if (slot != null && this.roomObject != null) {
      if (!slot.thermoActuatorTypes) slot.thermoActuatorTypes = {};
      slot.thermoActuatorTypes[this.roomObject.id ?? ''] =
        ThermoActuatorType.HeatingPump;
    }
  }

  isLimitationReached(slotsToBeMarked: Slot[] | null) {
    if (this.roomObject?.devices != null && slotsToBeMarked != null) {
      var noOfSelectedValves = this.roomObject.devices
        .flatMap((d) => d.slots)
        .filter((s) =>
          [
            ThermoActuatorType.HeatingPump,
            ThermoActuatorType.CoolingPump,
            ThermoActuatorType.HeatingAndCoolingPump,
          ].includes(
            this.getCurrentThermoActuatorType(
              s?.thermoActuatorTypes,
              this.roomObject.id
            )
          )
        ).length;

      var noOfSlotsToBeAddedInParam = slotsToBeMarked.filter(
        (s) =>
          this.getCurrentThermoActuatorType(
            s.thermoActuatorTypes,
            this.roomObject.id
          ) != ThermoActuatorType.HeatingPump
      ).length;

      if (
        noOfSelectedValves + noOfSlotsToBeAddedInParam <=
        this.MaximumNoOfThermostatSlots
      ) {
        return false;
      }
      return true;
    }

    return false;
  }
}
